import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LANGUAGES } from '@app/enums';
import { AnalyticsAction, AnalyticsCategory, GTagService } from '@app/shared/gtag.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'sba-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LanguageSelectorComponent {
  @Input() theme: 'white' | 'transparent' = 'transparent';
  languages;
  lang: any;

  constructor(
    private readonly translateService: TranslateService,
    private readonly ga: GTagService
  ) {
    const browserLang = navigator.language.split('-')[0];
    this.lang = LANGUAGES.find(l => l.value === (localStorage.getItem('LANGUAGE') || browserLang || 'en')) || LANGUAGES[0];
    this.languages = LANGUAGES.filter(l => l.value !== this.lang.value);
  }

  change(lang) {
    this.lang = lang;
    this.translateService.use(lang.value);
    this.languages = LANGUAGES.filter(l => l.value !== this.lang.value);
    localStorage.setItem('LANGUAGE', lang.value);
    this.ga.emit(
      AnalyticsCategory.LANGUAGE_SELECTOR,
      AnalyticsAction.CHANGE_LANGUAGE,
      lang.value
    );
  }
}

